import * as React from 'react'
import Table, { TableFilters, TableHeaderValue } from '@components/table/table'
import { CleaningOrder } from '@modules/housekeeping/models'
import { UnitDetailsCleaningOrdersTableRow } from '@modules/units/details/cleaning-orders/row'

const headerValues: TableHeaderValue<CleaningOrder>[] = [
  { title: 'Data zlecenia', sortField: 'date' },
  { title: 'Status', sortField: 'status' },
  { title: 'Typ', sortField: 'service_kind' },
  { title: 'Zlecający', sortField: 'order_created_by__name' },
  { title: 'Wykonawca' },
  { title: 'Data zakończenia', sortField: 'finished_at' },
]

interface Props {
  cleaningOrders: CleaningOrder[]
  filters: TableFilters
  setFilters: React.Dispatch<React.SetStateAction<TableFilters>>
}

export const UnitDetailsCleaningOrdersTable: React.FC<Props> = ({ cleaningOrders, filters, setFilters }) => (
  <Table
    className="table-hover w-100"
    headerValues={headerValues}
    isLoading={false}
    filters={filters}
    setFilters={setFilters}
  >
    {cleaningOrders.map(cleaningOrder => (
      <UnitDetailsCleaningOrdersTableRow key={cleaningOrder.id} cleaningOrder={cleaningOrder} />
    ))}
  </Table>
)
